import React, { useState } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {CssBaseline, Toolbar} from '@mui/material';
import {createTheme, ThemeProvider} from '@mui/material/styles/';
import {themeOptions} from "../views/_shared";
import {Header} from "./Header/Header";
import {Footer} from "./Footer/Footer";
import {Sidebar} from "./Sidebar/Sidebar";

import {AppContainer, BodyContainer, ContentContainer} from "./App.styles";
import {AuthProvider} from "../_auth/authProvider";
import {AppRoutes} from "./Routes/Routes";
import {AUTH_CONFIG} from "../_appData";
import {CACHE_LOCATION_LOCAL_STORAGE} from "../_auth/js/constants";
import {CacheLocation} from "../_auth/js";
import {LicenseInfo} from "@mui/x-data-grid-pro";

LicenseInfo.setLicenseKey(
    "43f66dbfe0fe682e8cc688e6e13b9163T1JERVI6Mjk0OTUsRVhQSVJZPTE2NjMzODI4ODQwMDAsS0VZVkVSU0lPTj0x"
);

const appTheme = createTheme(themeOptions);

export const App: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const providerConfig = {
        domain: AUTH_CONFIG.domain,
        clientId: AUTH_CONFIG.client_id,
        cacheLocation: CacheLocation.LocalStorage,
        ...(AUTH_CONFIG.audience ? { audience: AUTH_CONFIG.audience } : null),
        redirectUri: window.location.origin,
    };

    return (
        <AuthProvider {...providerConfig}>
        <ThemeProvider theme={appTheme}>
            <CssBaseline/>
            <Router>
                <AppContainer>
                    {/* Header */}
                    <Header />
                    {/* Routes/Content Section Here */}
                    <BodyContainer>
                        <Sidebar />
                        <ContentContainer>
                            <Toolbar variant="dense"/>
                            <AppRoutes />
                        </ContentContainer>
                    </BodyContainer>
                    {/* Footer */}
                    <Footer />
                </AppContainer>
            </Router>
        </ThemeProvider>
        </AuthProvider>
    );
};

// export default App;
